const FEE_CHANGE_REQUEST_FIELDS = `
  __typename
  ... on ExhibitorFeeChangeRequest {
    id
    exhibitor_id
    tenant_id
    status_id
    pay
    pay_virtual
    pay_virtual_short
    current_pay
    current_pay_virtual
    current_pay_virtual_short
    description
    decision_message
    decision_date
    created_by
    its
    uts
    exhibitor {
      id
      contact { id firstname lastname }
    }
    status {
      id
      name
      translation_key
      hex_color
    }
    exhibitor_fee_change_request_log {
      id
      old_status { id name translation_key hex_color }
      new_status { id name translation_key hex_color }
      message
      its
    }
  }
  ... on ResultError {
    status_code
    message
    message_translation_key
  }
`;

export const MY_PENDING_EXHIBITOR_FEE_CHANGE_REQUEST = `
  query myPendingExhibitorFeeChangeRequest($tenant_id: Int!) {
    myPendingExhibitorFeeChangeRequest(tenant_id: $tenant_id) {
      ${FEE_CHANGE_REQUEST_FIELDS}
    }
  }
`;

export const MY_EXHIBITOR_FEE_CHANGE_REQUESTS = `
  query myExhibitorFeeChangeRequests($tenant_id: Int!, $skip: Int, $take: Int) {
    myExhibitorFeeChangeRequests(tenant_id: $tenant_id, skip: $skip, take: $take) {
      ${FEE_CHANGE_REQUEST_FIELDS}
    }
  }
`;

export const EXHIBITOR_FEE_CHANGE_REQUESTS = `
  query exhibitorFeeChangeRequests(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $filter: FilterExhibitorFeeChangeRequestInput
    $orderBy: ExhibitorFeeChangeRequestOrderInput
  ) {
    exhibitorFeeChangeRequests(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      filter: $filter
      orderBy: $orderBy
    ) {
      ${FEE_CHANGE_REQUEST_FIELDS}
    }
  }
`;

export const EXHIBITOR_FEE_CHANGE_REQUEST_COUNT = `
  query exhibitorFeeChangeRequestCount($tenant_id: Int!, $filter: FilterExhibitorFeeChangeRequestInput) {
    exhibitorFeeChangeRequestCount(tenant_id: $tenant_id, filter: $filter) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const AVAILABLE_FEE_CHANGE_ACTIONS = `
  query availableFeeChangeActions($input: AvailableFeeChangeActionsInput!, $tenant_id: Int!) {
    availableFeeChangeActions(input: $input, tenant_id: $tenant_id) {
      id
      name
      translation_key
      is_main_action
    }
  }
`;
